import React from "react";
import PropTypes from "prop-types"; 

import Select from "@mui/material/Select";
import { InputLabel, ListItemIcon, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const DropdownMenu = ({
  value,
  formControlStyle,
  elementLabel,
  elementStyle,
  onChangeAction,
  elementName,
  options,
  required,
  multiple,
  ...rest
}) => {
  return (
    <>
      <InputLabel id={elementName}>
        {elementLabel}
        {required && "*"}
      </InputLabel>
      <Select
        multiple={multiple}
        value={value}
        IconComponent={KeyboardArrowDownIcon}
        sx={{ ...elementStyle, textTransform: "capitalize" }}
        onChange={onChangeAction}
        inputProps={{
          name: elementName,
          id: elementName,
        }}
        {...rest}
      >
        {options.map((option) => (
          <MenuItem
            sx={{ textTransform: "capitalize" }}
            key={option.value}
            value={option.value}
          >
            {option.icon && (
              <ListItemIcon sx={{ display: "contents" }}>
                {option.icon}
              </ListItemIcon>
            )}
            &nbsp;{option.label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

DropdownMenu.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  formControlStyle: PropTypes.instanceOf(Object),
  elementLabel: PropTypes.string,
  onChangeAction: PropTypes.func.isRequired,
  elementStyle: PropTypes.instanceOf(Object),
  elementName: PropTypes.string.isRequired,
  options: PropTypes.instanceOf(Object).isRequired,
  multiple: PropTypes.bool,
};

DropdownMenu.defaultProps = {
  formControlStyle: {},
  elementStyle: {},
  multiple: false,
};

export default DropdownMenu;
